import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=9778a88c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9778a88c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9778a88c')) {
      api.createRecord('9778a88c', component.options)
    } else {
      api.reload('9778a88c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=9778a88c&scoped=true&", function () {
      api.rerender('9778a88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4EKx3r5XlwVPL/JS/comp/Accordion.vue"
export default component.exports